import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../contexts/auth-context";
import { NewSpinner } from "../../components/Spinner/NewSpinner";
import {useEffect, useState} from "react";
import Header from "../../components/Header/Header";

export default function ProtectedRoute() {
    const { isAuthenticated, isPending } = useAuth();
    const [ showSpinner, setShowSpinner ] = useState(false);

    useEffect(() => {
        if (!isPending) {
            setShowSpinner(false);
            return;
        }

        const t = setTimeout(() => setShowSpinner(true), 0);
        return () => clearTimeout(t);
    }, [isPending]);

    if (isPending) {
        return (
            <div>
                <Header fullWidth />
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '100px' }}>
                    <NewSpinner />
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/inloggen" replace />;
    }

    return isAuthenticated ? <Outlet /> : null;
}